import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { setSession } from 'lib/core/data/auth/session'
import { Spinner, EmptyContainer } from 'lib/ui'

export const Impersonate = () => {
  const params = useParams<{ token: string }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { isLoggedIn } = useCustomer()
  const token = params.token

  useEffect(() => {
    dispatch(setSession(token))
  }, [dispatch, token])

  useEffect(() => {
    if (isLoggedIn) {
      history.replace('/customer/account/dashboard')
    }
  }, [isLoggedIn, history])

  return (
    <EmptyContainer>
      <Spinner />
    </EmptyContainer>
  )
}
